const theme = {
  colors: {
    primary: "#417505",
    secondary: "#79A546",
    black: "#000000",
  },
  font: {
    baseFontFamily: "DIN, Arial, sans-serif",
    baseFontWeight: 400,
    baseFontSize: "16px",
  },
  borders: {
    borderPrimary: "3px solid #417505",
  },
  breakpoints: {
    xs: "576px",
    sm: "768px",
    md: "992px",
    lg: "1200px"
  }
};

export default theme;
